import React, { useContext, useMemo } from 'react'
import { LeagueContext } from '../../../../Context'
import { FeedItem, sendGamificationEngagement } from '../../../../Api'
import { useAuthContext } from '../../../../Context'
import { logEvent } from '../../../../Utils'
import { ANALYTICS_TAGS, gamificationEngagements } from '../../../../Constant'
import { FeedHeadlineList } from 'Components/Feed/FeedHeadlineList'

export const HeadlinesFromLeague: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { homeFeed } = useContext(LeagueContext)!
  const { isLoggedIn, userId } = useAuthContext()

  const headlines = useMemo(() => {
    if (homeFeed?.headlines && homeFeed.headlines.length > 0) {
      return homeFeed.headlines
    }
    return []
  }, [homeFeed])

  const handleHeadlineClick = async (headline: FeedItem, index: number) => {
    const engagement =
      headline.type === 'article'
        ? gamificationEngagements.ARTICLE_READ
        : headline.type === 'video'
        ? gamificationEngagements.VIDEO_WATCH
        : null
    if (isLoggedIn && userId && engagement) {
      await sendGamificationEngagement(userId, engagement, headline.id)
    }
    const eventName =
      headline.type === 'article'
        ? ANALYTICS_TAGS.article_click
        : ANALYTICS_TAGS.video_click
    log(headline, eventName, index)
  }

  const log = (headline: FeedItem, eventName: string, index: number) => {
    const params = {
      section: headline?.metaData?.section?.location || 'headlines',
      title: headline.title,
      tags: headline.tags,
      article_id: headline.id,
      feed_type: headline.type,
      item_id: headline.id,
      location: headline?.metaData?.section?.location ?? '',
      feed: 'home',
      position: index + 1,
    }
    Promise.all([
      logEvent(eventName, params),
      logEvent(ANALYTICS_TAGS.feed_item_click, params),
    ])
  }

  if (headlines.length === 0) {
    return null
  }

  return <FeedHeadlineList feedItems={headlines} handleItemClick={handleHeadlineClick} />
}
